import React from "react";
import { Link } from "react-router-dom";
import "./CollectedFood.css";

function NgoCollectedFood() {
  // Temporary dummy data (later replace with API)
  const collectedFood = [
    {
      id: 1,
      hotelName: "Green Leaf Hotel",
      foodTitle: "Veg Meals",
      quantity: "30 Plates",
      collectedDate: "18 Jan 2026",
      location: "Pune"
    },
    {
      id: 2,
      hotelName: "Sunrise Restaurant",
      foodTitle: "Rice & Dal",
      quantity: "20 Plates",
      collectedDate: "17 Jan 2026",
      location: "Mumbai"
    }
  ];

  return (
    <>
      {/* Header */}
      <header className="header">
        <div className="header-container">
          <h1 className="logo">SaveBite</h1>

          <nav className="navigation">
             <Link to="/ngo/collectedfood">Collected Food</Link>
            <Link to="/ngo/collectfood">Available Surplus</Link>
            <Link to="/ngo/dashboard">Dashboard</Link>
            
            <button className="myaccount-button">My Account</button>
          </nav>
        </div>
      </header>

      {/* Page Content */}
      <div className="collected-container">
        <h2 className="page-title">🍽️ Collected Food</h2>
        <p className="page-subtitle">
          A record of all surplus food you have successfully collected from hotels.
        </p>

        <div className="food-grid">
          {collectedFood.length === 0 ? (
            <p className="empty-text">No food collected yet.</p>
          ) : (
            collectedFood.map(food => (
              <div className="food-card" key={food.id}>
                <h3>{food.foodTitle}</h3>
                <p><strong>Hotel:</strong> {food.hotelName}</p>
                <p><strong>Quantity:</strong> {food.quantity}</p>
                <p><strong>Location:</strong> {food.location}</p>
                <p className="date">Collected on: {food.collectedDate}</p>
              </div>
            ))
          )}
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        © 2025 SaveBite. All rights reserved.
      </footer>
    </>
  );
}

export default NgoCollectedFood;
